import React from "react";
import { useNavigate } from "react-router-dom";
import { ExpenseCategoryManager } from "../../components/expenses/ExpenseCategoryManager";

// Thin Settings-nav wrapper around the same manager dialog the Expenses
// page already uses (via its "Manage Categories" button) — reused as-is
// rather than rebuilt, so this is purely a discoverability fix, not a new
// implementation. Closing returns to the Settings hub since this route has
// nothing else to show once the dialog goes away.
export const ExpenseCategoryManagement: React.FC = () => {
    const navigate = useNavigate();

    return (
        <ExpenseCategoryManager open={true} onClose={() => navigate("/settings")} />
    );
};
